var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.upgrade)?_c('div',{staticClass:"text-center",attrs:{"id":"browserBar"}},[_vm._v("\n    We have detected that your are using "+_vm._s(_vm.browser.name)+", for the best experience please install Google Chrome "),_c('a',{attrs:{"href":"https://www.google.com/chrome/"}},[_vm._v("here")])]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2930a2fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = IYcp
// module chunks = 1